function _slicedToArray(r, e) {
  return (
    _arrayWithHoles(r) ||
    _iterableToArrayLimit(r, e) ||
    _unsupportedIterableToArray(r, e) ||
    _nonIterableRest()
  );
}
function _nonIterableRest() {
  throw new TypeError(
    "Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."
  );
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return (
      "Object" === t && r.constructor && (t = r.constructor.name),
      "Map" === t || "Set" === t
        ? Array.from(r)
        : "Arguments" === t ||
            /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t)
          ? _arrayLikeToArray(r, a)
          : void 0
    );
  }
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function _iterableToArrayLimit(r, l) {
  var t =
    null == r
      ? null
      : ("undefined" != typeof Symbol && r[Symbol.iterator]) || r["@@iterator"];
  if (null != t) {
    var e,
      n,
      i,
      u,
      a = [],
      f = !0,
      o = !1;
    try {
      if (((i = (t = t.call(r)).next), 0 === l)) {
        if (Object(t) !== t) return;
        f = !1;
      } else
        for (
          ;
          !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l);
          f = !0
        );
    } catch (r) {
      ((o = !0), (n = r));
    } finally {
      try {
        if (!f && null != t.return && ((u = t.return()), Object(u) !== u))
          return;
      } finally {
        if (o) throw n;
      }
    }
    return a;
  }
}
function _arrayWithHoles(r) {
  if (Array.isArray(r)) return r;
}
define("SDB.SelectWheelsOrTires.SS2Model", [
  "SCModel",
  "Utils",
  "AjaxRequestsKiller",
  "Singleton",
], function (SCModelComponent, Utils, AjaxRequestsKiller, Singleton) {
  "use strict";

  var SCModel = SCModelComponent.SCModel;

  var SDBSelectWheelsOrTiresSS2Model =
    function SDBSelectWheelsOrTiresSS2Model() {
      SCModel.call(this);

      this.urlRoot = function () {
        return Utils.getAbsoluteUrl(
          getExtensionAssetsPath(
            "Modules/SDBSelectYourVehicle/SuiteScript2/SDB.SelectWheelsOrTires.Service.ss"
          ),
          true
        );
      };

      var defaultCookieOptions = [
        "vehicleConfig",
        "frontSizeDescription",
        "vehicle",
        "isSelectedTires",
        "selectedSize",
      ];

      this.setCookieOptions = function setCookieOptions(data) {
        this.removeCookieOptions();
        var pairedValues = _.pairs(data);

        _.each(pairedValues, function (_ref) {
          var _ref2 = _slicedToArray(_ref, 2),
            name = _ref2[0],
            value = _ref2[1];
          document.cookie = name + "=" + value + "; path=/;";
        });
        this.set(data, { wait: true });
      };

      this.getCookieOptions = function getCookieOptions() {
        var options =
          arguments.length > 0 && arguments[0] !== undefined
            ? arguments[0]
            : defaultCookieOptions;
        var cookieOptions = document.cookie.split(";");

        var arrCookies = _.filter(cookieOptions, function (cookie) {
          return _.contains(options, cookie.split("=")[0].trim());
        });

        return arrCookies;
      };

      this.getParsedCookieOptions = function getParsedCookieOptions() {
        var options =
          arguments.length > 0 && arguments[0] !== undefined
            ? arguments[0]
            : defaultCookieOptions;
        var cookieOptions = this.getCookieOptions(options);

        var arrCookies = _.map(cookieOptions, function (cookie) {
          return cookie.trim().split("=");
        });

        return _.object(arrCookies);
      };

      this.removeCookieOptions = function removeCookieOptions(
        specifiedCookies
      ) {
        _.each(this.getCookieOptions(), function (cookie) {
          cookie = cookie.split("=")[0].trim();
          document.cookie =
            cookie + "=; expires=Thu, 01 Jan 1970 00:00:01 GMT; path=/;";
        });
      };

      _.each(
        this.getCookieOptions(),
        function (cookie) {
          var name = cookie.split("=")[0].trim();
          var value = cookie.split("=")[1];
          this.set(name, value, { wait: true });
        },
        this
      );
    };

  SDBSelectWheelsOrTiresSS2Model.prototype = SCModel.prototype;
  SDBSelectWheelsOrTiresSS2Model.prototype.constructor =
    SDBSelectWheelsOrTiresSS2Model;

  return _.extend(SDBSelectWheelsOrTiresSS2Model, Singleton);
});
